/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Nikolay Sviridov
 * @version 1.37.0
 * @since 1.15.0
 */

import classNames from 'classnames';
import { TooltipRenderProps } from 'react-joyride';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ImgStyled } from '@components/common/Block/Img';
import { ELinkTarget } from '@components/common/ExternalLink/ExternalLink';
import { IRootReducer } from '@reducers/rootReducer';

import { icons } from '../../../assets';
import { Button, LinkBlock } from '../../../components/common';
import { IOnboardingReducer } from '../onboardingReducer';
import { makeSelectOnboardingIsWelcomeOnboardingCompleted } from '../onboardingSelectors';
import { IOnboardingStep } from '../types/onboardingTypes';
import { OnboardingTooltipStyled } from './styled/OnboardingTooltipStyled';

const OnboardingTooltip = ({
                               backProps,
                               index,
                               isWelcomeOnboardingCompleted,
                               primaryProps,
                               size,
                               skipProps,
                               step,
                               tooltipProps,
                           }: TooltipRenderProps & { step: IOnboardingStep } & IConnectedProps) => {

    const isButtonsShown = size > 1 || !isWelcomeOnboardingCompleted;

    return (
        <OnboardingTooltipStyled {...tooltipProps}>
            <ImgStyled
                className="small pointer onboarding-tooltip__cross"
                data-name="onboarding-tooltip-cross"
                src={icons.removeSmallOpacityIcon}
                {...skipProps}
            />
            <div className="onboarding-tooltip__text" dangerouslySetInnerHTML={{ __html: step.text }}/>
            <div className="onboarding-tooltip__control">
                <div className="onboarding-tooltip__link">
                    <LinkBlock
                        isExternalUrl
                        dataName="onboarding-tooltip-link"
                        target={ELinkTarget.BLANK}
                        url={step.link.url}
                    >
                        {step.link.label}
                    </LinkBlock>
                </div>
                {
                    isButtonsShown && (
                        <div className="onboarding-tooltip__page">
                            <div className={classNames('onboarding-tooltip__arrow onboarding-tooltip__arrow_left', {
                                'onboarding-tooltip__arrow_disabled': index === 0,
                            })}>
                                <ImgStyled
                                    className={classNames('small', { disabled: index === 0 })}
                                    data-name="onboarding-tooltip-arrow-left"
                                    src={index !== 0 ? icons.arrowLeftSuccessIcon : icons.arrowLeftDisabledIcon}
                                    {...backProps}
                                />
                            </div>
                            <Button
                                {...{ ...primaryProps, onClick: (e) => primaryProps.onClick(e as any) }}
                            >
                                {step.page.next}
                            </Button>
                        </div>
                    )
                }
            </div>
        </OnboardingTooltipStyled>
    );
};

type TReducer = Pick<IOnboardingReducer, 'isWelcomeOnboardingCompleted'>;

type IConnectedProps = TReducer;

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    isWelcomeOnboardingCompleted: makeSelectOnboardingIsWelcomeOnboardingCompleted(),
});

export default connect(mapStateToProps)(OnboardingTooltip);
